export default __webpack_public_path__ + "static/media/imgDark6.f9472588.png";